import {Fragment, observer, React} from '@api'
import {BorderTabSet, LayoutStore, useLayoutStore} from '@flexlayout'

export class BordersStore {
  constructor(public store: LayoutStore) {}
}

export const Borders = observer(function Borders() {
  const store = useLayoutStore(),
    {props: {model: {borderSet}, icons, iconFactory, titleFactory}} = store

  return (
    <Fragment>
      {borderSet.borders.filter(b => b.isShowing).map(b => (
        <BorderTabSet
          key={'border_' + b.location.name}
          border={b}
          layout={store}
          iconFactory={iconFactory}
          titleFactory={titleFactory}
          icons={icons}
        />))}
    </Fragment>)
})



// WEBPACK FOOTER //
// ./src/stores/catalog/flexLayout/flexlayout-react/src/view/Layout/Borders.tsx